export function join(strArr, joinChar) {
    if (0 === strArr.length) return;
    let str = "";
    for (let i = 0; i < strArr.length; i++) str += strArr[i], i !== strArr.length - 1 && (str += joinChar);
    return str;
}
//# sourceMappingURL=join.js.map
